var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#C9A145;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13_00000160884937609705910940000016084208330083286716_",
    transform: "translate(-229.329 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1595_00000132787193260074143000000010950025513558416027_",
    transform: "translate(229.329 18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12c0-2.4,0.7-4.7,2-6.7C4.2,2,8,0,12,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,1c-1.9,0-3.7,0.5-5.4,1.4C5.1,3.2,3.8,4.4,2.9,5.9C1.6,7.8,1,9.8,1,12c0,2.9,1.1,5.7,3.2,7.8 C6.3,21.9,9.1,23,12,23s5.7-1.1,7.8-3.2c2.1-2.1,3.2-4.8,3.2-7.8s-1.1-5.7-3.2-7.8C17.7,2.1,14.9,1,12,1 M12,0c6.6,0,12,5.4,12,12 s-5.4,12-12,12S0,18.6,0,12c0-2.4,0.7-4.6,2-6.7C4,2.2,7.7,0,12,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33__00000054962347724503225350000014227753580681440641_",
    transform: "translate(234.659 22.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55_00000113320034805242206610000014081573347201832590_",
    className: "st1",
    d: "M6.7,15c-1,0-1.8-0.8-1.8-1.8v-0.3h3.7 v0.3C8.5,14.2,7.7,15,6.7,15z M5.5,13.5c0.2,0.7,0.8,1.1,1.5,0.9c0.4-0.1,0.8-0.5,0.9-0.9H5.5z M11.6,12.1l0.6-0.1l-0.7-2.8V6.8 c0-2.1-1.4-4-3.4-4.6V1.5C8.2,0.7,7.5,0,6.7,0c-0.8,0-1.5,0.6-1.5,1.4c0,0,0,0.1,0,0.1v0.7c-2,0.6-3.4,2.5-3.4,4.6v2.4l-0.7,2.8 l0.6,0.1l0.6-2.6H11L11.6,12.1z M10.9,8.9H2.4V8.1h8.5L10.9,8.9L10.9,8.9z M5.8,1.5c0-0.5,0.4-0.9,0.9-0.9S7.5,1,7.5,1.5V2 C7,1.9,6.4,1.9,5.8,2V1.5z M6.7,2.5c2.4,0,4.3,1.9,4.3,4.3v0.7H2.4V6.8C2.4,4.4,4.3,2.5,6.7,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56_00000180366938982529587410000005766582715356251833_",
    className: "st1",
    d: "M12.4,13.5H0.9C0.4,13.5,0,13,0,12.5 s0.4-0.9,0.9-0.9h11.5c0.5,0,0.9,0.4,0.9,0.9S12.9,13.5,12.4,13.5z M0.9,12.2c-0.2,0-0.3,0.2-0.3,0.3s0.2,0.3,0.3,0.3h11.5 c0.2,0,0.3-0.2,0.3-0.3s-0.2-0.3-0.3-0.3H0.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.a4da89d7c8226f37902642252e669bdb.svg";
export { ForwardRef as ReactComponent };